import React, { Component } from 'react';
import './About.css';
import * as appsettings from './constants';
export class About extends Component {
    displayName = About.name
    constructor(props) {
        super(props);
        this.today = new Date();
        this.today.setDate(this.today.getDate());
        this.today.setHours(this.today.getHours() - 2);
        this.today.setMinutes(30);
        this.today.setSeconds(0);
        this.state = { Metric: [], fromDate: this.today.toISOString(), environment: 'Prod', loading: false };
    }
    componentDidMount() {
        
    }
    render() {
        return (
            <div>
                <p id='Title'>About the Website !</p>
                <hr/>
                <ul>
                    <li>
                        <p>The HourlyView Page gives the ARP values of the services for an hour having starting time as the selected DateTime </p>
                    </li>
                    <li>
                        <p>The DailyView Page gives the ARP values of the services for 24 hours having starting time as the selected DateTime</p>
                    </li>
                    <li>
                        <p>The CustomView Page gives the ARP values of the services between the selected Date and time range</p>
                    </li>
                    <li>
                        <p>The MonthlyView Reliability page give the summarized monthly reliability values for the past 6 months</p>
                    </li>
                </ul>
                <hr />
                <p id='Title'>Color Coding of Metrics !</p>
                <hr />
                <ul>
                    <li>
                        <p>Green : Excellent , Orange : Satisfactory, Red: Needs Improvement</p>
                    </li>
                    <li>
                        <p>Availability : Green >= {appsettings.AvailabilityGreenTarget},Orange>= {appsettings.AvailabilityOrangeTarget} else Red</p>
                    </li>
                    <li>
                        <p>Reliability : Green >= {appsettings.ReliabilityGreenTarget},Orange>= {appsettings.ReliabilityOrangeTarget} else Red</p>
                    </li>
                    <li>
                        <p>Performance : Green >= {appsettings.PerformanceGreenTarget},Orange>= {appsettings.PerformanceOrangeTarget} else Red</p>
                    </li>
                    <li>
                        NOTE : For Monthly View only green and red colors are used and all values above satisfactory are shown as green
                    </li>
                </ul>
                <hr />
                <p id='Title'>Some key features !</p>
                <hr />
                <ul>
                    <li>
                        <p>Filtering - Typing in the box just below the column header will filter the data according to its type.
                                If it's of numerical type , typing a value will display all values smaller than the input value and for
                            columns having text data will be filtered by the string matching algorithm.</p>
                        </li>
                    <li>
                    <p>Sorting - Clicking on the column headers will sort the column and holding shift will selecting the headers will 
                        multi-sort the table data according to the selected columns.</p>
                        </li>
                </ul>
            </div>
        );
    }
}
